import ErrorView from 'components/ErrorView';
import useCommon from 'hooks/useCommon';
import { capitalize } from 'libs/utils';
import React, { FunctionComponent } from 'react';
import useNavigator from 'hooks/useNavigator';

const NotFound: FunctionComponent = () => {
  const { title } = useCommon();
  const { navigateCallback } = useNavigator();

  return (
    <ErrorView
      title="Something went wrong, your email is not verified. Please, contact the admins of the account."
      message="You can return to website!"
      actionTitle={capitalize(title)}
      onClick={navigateCallback('/')}
    />
  );
};

export default NotFound;
